
import * as React from "react";

const Canada: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" fill="#E5E5E5"/>
        <g filter="url(#filter0_d)">
        <rect width="280" height="513" transform="translate(-20 -35)" fill="white"/>
        <mask id="mask0"  maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <path d="M0.0585938 0.0582275H23.9769V23.9185H0.0585938V0.0582275Z" fill="white"/>
        </mask>
        <g mask="url(#mask0)">
        <path fillRule="evenodd" clipRule="evenodd" d="M23.977 11.9884C23.977 18.577 18.6225 23.9185 12.0178 23.9185C5.41281 23.9185 0.0585938 18.577 0.0585938 11.9884C0.0585938 5.39945 5.41281 0.0582275 12.0178 0.0582275C18.6225 0.0582275 23.977 5.39945 23.977 11.9884Z" fill="#F3F3F3"/>
        </g>
        <path fillRule="evenodd" clipRule="evenodd" d="M23.9768 11.9884C23.9768 7.25855 21.2174 3.17179 17.2172 1.24194V22.7346C21.2174 20.805 23.9768 16.7182 23.9768 11.9884Z" fill="#D80027"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0.0585938 11.9884C0.0585938 16.7182 2.81795 20.805 6.81818 22.7346V1.24194C2.81795 3.17179 0.0585938 7.25855 0.0585938 11.9884Z" fill="#D80027"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M12.4208 16.837L12.304 14.9895L13.7415 15.3973L13.5136 14.5347L15.827 14.7206L15.4183 13.6721L16.7614 12.3905L15.0791 11.8719V10.718L13.116 11.9302L14.156 9.15638L12.9992 9.33114L12.0178 7.71667L11.0947 9.33114L9.87954 9.15638L10.9195 11.9302L8.95639 10.718V11.8719L7.27417 12.3905L8.61724 13.6721L8.20848 14.7206L10.5219 14.5347L10.294 15.3973L11.7315 14.9895L11.6147 16.837H12.4208Z" fill="#D80027"/>
        </g>
        <defs>
        <filter id="filter0_d" x="-40" y="-51" width="320" height="553" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="10"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        </defs>
        </svg>
    );
};

export default React.memo(Canada);
